// FLAG:useDocuAi — the document's explicitly stated payment method mapped onto the
// system payment types (card/cash/PayPal are lazily created per flag-ON tenant at ingest).
const DOCUAI_METHOD_TO_PAY_KIND_TITLE: Record<string, string> = {
  credit_transfer: 'SEPA Überweisung',
  direct_debit: 'Lastschrift',
  card: 'Karte',
  cash: 'Bar',
  paypal: 'PayPal',
}

export type DocuAiPayKind = { id: number, title: string }

export const resolveDocuAiPayKindId = (
  payKinds: DocuAiPayKind[],
  paymentMethodCode?: string | null,
): number | undefined => {
  const title = paymentMethodCode ? DOCUAI_METHOD_TO_PAY_KIND_TITLE[paymentMethodCode] : undefined
  return title ? payKinds.find(kind => kind.title === title)?.id : undefined
}
